/* tslint:disable */
/* eslint-disable */
/**
 * Partner Service API
 * API contract for partner service
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ben@xp-lab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddPeopleToCohortRequest
 */
export interface AddPeopleToCohortRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPeopleToCohortRequest
     */
    'cohortId': string;
    /**
     * 
     * @type {Array<CohortPersonInput>}
     * @memberof AddPeopleToCohortRequest
     */
    'people': Array<CohortPersonInput>;
}
/**
 * 
 * @export
 * @interface AddPeopleToCohortResponse
 */
export interface AddPeopleToCohortResponse {
    /**
     * 
     * @type {Cohort}
     * @memberof AddPeopleToCohortResponse
     */
    'data': Cohort;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddPeopleToCohortResponse
     */
    'createdPersonIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddPublicPersonRequest
 */
export interface AddPublicPersonRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPublicPersonRequest
     */
    'assignmentId': string;
    /**
     * 
     * @type {string}
     * @memberof AddPublicPersonRequest
     */
    'cohortId': string;
    /**
     * 
     * @type {string}
     * @memberof AddPublicPersonRequest
     */
    'personId': string;
}
/**
 * 
 * @export
 * @interface AddPublicPersonResponse
 */
export interface AddPublicPersonResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AddPublicPersonResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AdminCleanupPersonRequest
 */
export interface AdminCleanupPersonRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCleanupPersonRequest
     */
    'personId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCleanupPersonRequest
     */
    'dryRun': boolean;
}
/**
 * 
 * @export
 * @interface AdminCleanupPersonResponse
 */
export interface AdminCleanupPersonResponse {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminCleanupPersonResponse
     */
    'assignments': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminCleanupPersonResponse
     */
    'cohorts': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof AdminCleanupPersonResponse
     */
    'removedFromAssignments': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCleanupPersonResponse
     */
    'removedFromCohorts': number;
}
/**
 * 
 * @export
 * @interface Assignment
 */
export interface Assignment {
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'cohortId': string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'organizationId': string;
    /**
     * Optional time limit in minutes for the challenge once started
     * @type {number}
     * @memberof Assignment
     */
    'timeLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'overdueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Assignment
     */
    'personIds': Array<string>;
    /**
     * 
     * @type {AssignmentStatus}
     * @memberof Assignment
     */
    'status': AssignmentStatus;
    /**
     * 
     * @type {number}
     * @memberof Assignment
     */
    'submissions': number;
    /**
     * 
     * @type {AssignmentSettings}
     * @memberof Assignment
     */
    'settings'?: AssignmentSettings;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    'linkToken'?: string;
}


/**
 * 
 * @export
 * @interface AssignmentDetails
 */
export interface AssignmentDetails {
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'personId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'assignmentId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'taskId': string;
    /**
     * 
     * @type {AssignmentDetailsStatus}
     * @memberof AssignmentDetails
     */
    'status': AssignmentDetailsStatus;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'challengeId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssignmentDetails
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'feedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'solution'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssignmentDetails
     */
    'workTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'submitDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDetails
     */
    'isPublicAssignment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetails
     */
    'createdAt'?: string;
    /**
     * Display name of the cohort (Position or Class) this assignment belongs to
     * @type {string}
     * @memberof AssignmentDetails
     */
    'cohortName'?: string;
    /**
     * Object map of charts with chart IDs as keys and chart data as values
     * @type {{ [key: string]: Chart; }}
     * @memberof AssignmentDetails
     */
    'charts'?: { [key: string]: Chart; };
    /**
     * 
     * @type {AssignmentDetailsQueries}
     * @memberof AssignmentDetails
     */
    'queries'?: AssignmentDetailsQueries;
}


/**
 * 
 * @export
 * @interface AssignmentDetailsQueries
 */
export interface AssignmentDetailsQueries {
    /**
     * Total number of queries executed
     * @type {number}
     * @memberof AssignmentDetailsQueries
     */
    'totalCount': number;
    /**
     * Last 20 query entries (most recent first)
     * @type {Array<AssignmentDetailsQueryEntry>}
     * @memberof AssignmentDetailsQueries
     */
    'last20': Array<AssignmentDetailsQueryEntry>;
}
/**
 * 
 * @export
 * @interface AssignmentDetailsQueryEntry
 */
export interface AssignmentDetailsQueryEntry {
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetailsQueryEntry
     */
    'query': string;
    /**
     * 
     * @type {number}
     * @memberof AssignmentDetailsQueryEntry
     */
    'resultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDetailsQueryEntry
     */
    'errorCode'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentDetailsStatus = {
    Sent: 'sent',
    Started: 'started',
    Submitted: 'submitted',
    Forfeited: 'forfeited'
} as const;

export type AssignmentDetailsStatus = typeof AssignmentDetailsStatus[keyof typeof AssignmentDetailsStatus];


/**
 * 
 * @export
 * @interface AssignmentDisclaimerResponse
 */
export interface AssignmentDisclaimerResponse {
    /**
     * 
     * @type {string}
     * @memberof AssignmentDisclaimerResponse
     */
    'assignmentDisclaimer': string;
}
/**
 * 
 * @export
 * @interface AssignmentListResponse
 */
export interface AssignmentListResponse {
    /**
     * 
     * @type {Array<Assignment>}
     * @memberof AssignmentListResponse
     */
    'assignments': Array<Assignment>;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof AssignmentListResponse
     */
    'organizations': Array<Organization>;
}
/**
 * 
 * @export
 * @interface AssignmentResponse
 */
export interface AssignmentResponse {
    /**
     * 
     * @type {Assignment}
     * @memberof AssignmentResponse
     */
    'data': Assignment;
}
/**
 * 
 * @export
 * @interface AssignmentSettings
 */
export interface AssignmentSettings {
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentSettings
     */
    'releaseFeedbacks'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentStatus = {
    Inactive: 'inactive',
    Active: 'active'
} as const;

export type AssignmentStatus = typeof AssignmentStatus[keyof typeof AssignmentStatus];


/**
 * 
 * @export
 * @interface Chart
 */
export interface Chart {
    /**
     * The unique identifier for the chart
     * @type {string}
     * @memberof Chart
     */
    'id'?: string;
    /**
     * 
     * @type {ChartTypeEnum}
     * @memberof Chart
     */
    'chartType': ChartTypeEnum;
    /**
     * The x-axis label for the chart (optional)
     * @type {string}
     * @memberof Chart
     */
    'xAxis'?: string;
    /**
     * The y-axis label for the chart (optional)
     * @type {string}
     * @memberof Chart
     */
    'yAxis'?: string;
    /**
     * The SQL query used to generate the chart data
     * @type {string}
     * @memberof Chart
     */
    'query': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof Chart
     */
    'data'?: Array<object>;
    /**
     * Whether to show trend line for scatter charts
     * @type {boolean}
     * @memberof Chart
     */
    'showTrendLine'?: boolean;
}


/**
 * The type of chart for data visualization
 * @export
 * @enum {string}
 */

export const ChartTypeEnum = {
    Table: 'table',
    Line: 'line',
    Bar: 'bar',
    Pie: 'pie',
    Scatter: 'scatter'
} as const;

export type ChartTypeEnum = typeof ChartTypeEnum[keyof typeof ChartTypeEnum];


/**
 * 
 * @export
 * @interface Cohort
 */
export interface Cohort {
    /**
     * 
     * @type {string}
     * @memberof Cohort
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Cohort
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Cohort
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Cohort
     */
    'organizationId': string;
    /**
     * 
     * @type {CohortType}
     * @memberof Cohort
     */
    'type': CohortType;
    /**
     * 
     * @type {boolean}
     * @memberof Cohort
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Cohort
     */
    'personIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Cohort
     */
    'challengeDisclaimer'?: string;
}


/**
 * 
 * @export
 * @interface CohortListResponse
 */
export interface CohortListResponse {
    /**
     * 
     * @type {Array<Cohort>}
     * @memberof CohortListResponse
     */
    'data': Array<Cohort>;
}
/**
 * 
 * @export
 * @interface CohortPersonInput
 */
export interface CohortPersonInput {
    /**
     * 
     * @type {string}
     * @memberof CohortPersonInput
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CohortPersonInput
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CohortPersonInput
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CohortResponse
 */
export interface CohortResponse {
    /**
     * 
     * @type {Cohort}
     * @memberof CohortResponse
     */
    'data': Cohort;
    /**
     * 
     * @type {Array<AssignmentDetails>}
     * @memberof CohortResponse
     */
    'assignmentsDetails'?: Array<AssignmentDetails>;
    /**
     * 
     * @type {Array<Assignment>}
     * @memberof CohortResponse
     */
    'publicAssignments'?: Array<Assignment>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CohortType = {
    Position: 'position',
    Class: 'class'
} as const;

export type CohortType = typeof CohortType[keyof typeof CohortType];


/**
 * 
 * @export
 * @interface CreateAssignmentRequest
 */
export interface CreateAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    'cohortId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    'taskId': string;
    /**
     * Optional time limit in minutes for the challenge once started
     * @type {number}
     * @memberof CreateAssignmentRequest
     */
    'timeLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    'overdueDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAssignmentRequest
     */
    'personIds': Array<string>;
    /**
     * 
     * @type {AssignmentSettings}
     * @memberof CreateAssignmentRequest
     */
    'settings'?: AssignmentSettings;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAssignmentRequest
     */
    'public'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCohortRequest
 */
export interface CreateCohortRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCohortRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCohortRequest
     */
    'description'?: string;
    /**
     * 
     * @type {CohortType}
     * @memberof CreateCohortRequest
     */
    'type': CohortType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCohortRequest
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCohortRequest
     */
    'personIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCohortRequest
     */
    'challengeDisclaimer'?: string;
}


/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganizationRequest
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'logoURL'?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof CreateOrganizationRequest
     */
    'type': OrganizationType;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrganizationRequest
     */
    'availableTaskIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: ErrorResponseErrorCodeEnum;
}

export const ErrorResponseErrorCodeEnum = {
    OrganizationIdRequired: 'organizationIdRequired',
    BadRequest: 'badRequest',
    CohortNotFound: 'cohortNotFound',
    CohortNotInOrganization: 'cohortNotInOrganization',
    CohortIdRequired: 'cohortIdRequired',
    AssignmentNotFound: 'assignmentNotFound',
    AssignmentAlreadySent: 'assignmentAlreadySent',
    InvalidAssignmentScope: 'invalidAssignmentScope',
    InvalidAssignmentStatus: 'invalidAssignmentStatus',
    OrganizationNotFound: 'organizationNotFound',
    InvalidOrganizationType: 'invalidOrganizationType',
    AlreadyJoinedPublicAssignment: 'alreadyJoinedPublicAssignment'
} as const;

export type ErrorResponseErrorCodeEnum = typeof ErrorResponseErrorCodeEnum[keyof typeof ErrorResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organization
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'logoURL'?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof Organization
     */
    'type': OrganizationType;
    /**
     * 
     * @type {Array<string>}
     * @memberof Organization
     */
    'availableTaskIds'?: Array<string>;
    /**
     * 
     * @type {OrganizationSettings}
     * @memberof Organization
     */
    'settings'?: OrganizationSettings;
    /**
     * 
     * @type {OrganizationAdminSettings}
     * @memberof Organization
     */
    'adminSettings'?: OrganizationAdminSettings;
}


/**
 * 
 * @export
 * @interface OrganizationAdminSettings
 */
export interface OrganizationAdminSettings {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdminSettings
     */
    'allowPublicLinks'?: boolean;
}
/**
 * 
 * @export
 * @interface OrganizationListResponse
 */
export interface OrganizationListResponse {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationListResponse
     */
    'data': Array<Organization>;
}
/**
 * 
 * @export
 * @interface OrganizationResponse
 */
export interface OrganizationResponse {
    /**
     * 
     * @type {Organization}
     * @memberof OrganizationResponse
     */
    'data': Organization;
}
/**
 * 
 * @export
 * @interface OrganizationSearchResult
 */
export interface OrganizationSearchResult {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResult
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResult
     */
    'name'?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof OrganizationSearchResult
     */
    'type'?: OrganizationType;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSearchResult
     */
    'active'?: boolean;
}


/**
 * 
 * @export
 * @interface OrganizationSettings
 */
export interface OrganizationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettings
     */
    'invitationEmails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSettings
     */
    'submissionEmails'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSettings
     */
    'feedbackLanguage'?: OrganizationSettingsFeedbackLanguageEnum;
}

export const OrganizationSettingsFeedbackLanguageEnum = {
    En: 'en',
    He: 'he',
    Es: 'es',
    Fr: 'fr',
    De: 'de'
} as const;

export type OrganizationSettingsFeedbackLanguageEnum = typeof OrganizationSettingsFeedbackLanguageEnum[keyof typeof OrganizationSettingsFeedbackLanguageEnum];

/**
 * Sortable fields for organizations
 * @export
 * @enum {string}
 */

export const OrganizationSortFieldEnum = {
    Id: 'id',
    Name: 'name',
    Type: 'type',
    Active: 'active',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt'
} as const;

export type OrganizationSortFieldEnum = typeof OrganizationSortFieldEnum[keyof typeof OrganizationSortFieldEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationType = {
    Company: 'company',
    School: 'school'
} as const;

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];


/**
 * 
 * @export
 * @interface OrganizationsGetQueryFiltersParameter
 */
export interface OrganizationsGetQueryFiltersParameter {
    /**
     * 
     * @type {OrganizationType}
     * @memberof OrganizationsGetQueryFiltersParameter
     */
    'type'?: OrganizationType;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationsGetQueryFiltersParameter
     */
    'active'?: boolean;
}


/**
 * 
 * @export
 * @interface PartnerDashboardResponse
 */
export interface PartnerDashboardResponse {
    /**
     * 
     * @type {Array<AssignmentDetails>}
     * @memberof PartnerDashboardResponse
     */
    'recentAssignments': Array<AssignmentDetails>;
}
/**
 * 
 * @export
 * @interface RemovePeopleFromCohortRequest
 */
export interface RemovePeopleFromCohortRequest {
    /**
     * 
     * @type {string}
     * @memberof RemovePeopleFromCohortRequest
     */
    'cohortId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemovePeopleFromCohortRequest
     */
    'peopleIds': Array<string>;
}
/**
 * 
 * @export
 * @interface RemovePeopleFromCohortResponse
 */
export interface RemovePeopleFromCohortResponse {
    /**
     * 
     * @type {Cohort}
     * @memberof RemovePeopleFromCohortResponse
     */
    'data': Cohort;
}
/**
 * 
 * @export
 * @interface SetAssignmentStatusRequest
 */
export interface SetAssignmentStatusRequest {
    /**
     * 
     * @type {AssignmentStatus}
     * @memberof SetAssignmentStatusRequest
     */
    'status': AssignmentStatus;
}


/**
 * Sort direction
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface UpdateAssignmentRequest
 */
export interface UpdateAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'cohortId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'ownerId': string;
    /**
     * Optional time limit in minutes for the challenge once started
     * @type {number}
     * @memberof UpdateAssignmentRequest
     */
    'timeLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'overdueDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAssignmentRequest
     */
    'personIds': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateAssignmentRequest
     */
    'submissions'?: number;
    /**
     * 
     * @type {AssignmentSettings}
     * @memberof UpdateAssignmentRequest
     */
    'settings'?: AssignmentSettings;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    'linkToken'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCohortRequest
 */
export interface UpdateCohortRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCohortRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCohortRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCohortRequest
     */
    'organizationId': string;
    /**
     * 
     * @type {CohortType}
     * @memberof UpdateCohortRequest
     */
    'type': CohortType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCohortRequest
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCohortRequest
     */
    'personIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCohortRequest
     */
    'challengeDisclaimer'?: string;
}


/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationRequest
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'logoURL'?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof UpdateOrganizationRequest
     */
    'type': OrganizationType;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrganizationRequest
     */
    'availableTaskIds'?: Array<string>;
    /**
     * 
     * @type {OrganizationSettings}
     * @memberof UpdateOrganizationRequest
     */
    'settings'?: OrganizationSettings;
    /**
     * 
     * @type {OrganizationAdminSettings}
     * @memberof UpdateOrganizationRequest
     */
    'adminSettings'?: OrganizationAdminSettings;
}


/**
 * 
 * @export
 * @interface UpdateOrganizationSettingsRequest
 */
export interface UpdateOrganizationSettingsRequest {
    /**
     * 
     * @type {OrganizationSettings}
     * @memberof UpdateOrganizationSettingsRequest
     */
    'settings': OrganizationSettings;
}
/**
 * 
 * @export
 * @interface VerifyLinkTokenResponse
 */
export interface VerifyLinkTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyLinkTokenResponse
     */
    'valid': boolean;
    /**
     * Organization ID from the assignment (only present when valid is true)
     * @type {string}
     * @memberof VerifyLinkTokenResponse
     */
    'organizationId'?: string;
    /**
     * Organization name from the assignment (only present when valid is true)
     * @type {string}
     * @memberof VerifyLinkTokenResponse
     */
    'organizationName'?: string;
    /**
     * Assignment ID (only present when valid is true)
     * @type {string}
     * @memberof VerifyLinkTokenResponse
     */
    'assignmentId'?: string;
    /**
     * Task name from the assignment (only present when valid is true)
     * @type {string}
     * @memberof VerifyLinkTokenResponse
     */
    'taskName'?: string;
    /**
     * Cohort ID from the assignment (only present when valid is true)
     * @type {string}
     * @memberof VerifyLinkTokenResponse
     */
    'cohortId'?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Remove a person from all assignments and cohorts (internal)
         * @param {AdminCleanupPersonRequest} adminCleanupPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupPerson: async (adminCleanupPersonRequest: AdminCleanupPersonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCleanupPersonRequest' is not null or undefined
            assertParamExists('adminCleanupPerson', 'adminCleanupPersonRequest', adminCleanupPersonRequest)
            const localVarPath = `/admin/cleanup-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCleanupPersonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignment disclaimer for an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentDisclaimerGet: async (assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentDisclaimerGet', 'assignmentId', assignmentId)
            const localVarPath = `/assignment-disclaimer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assignmentId !== undefined) {
                localVarQueryParameter['assignmentId'] = assignmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a person to a public assignment and its cohort
         * @param {AddPublicPersonRequest} addPublicPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAddPublicPersonPost: async (addPublicPersonRequest: AddPublicPersonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPublicPersonRequest' is not null or undefined
            assertParamExists('assignmentsAddPublicPersonPost', 'addPublicPersonRequest', addPublicPersonRequest)
            const localVarPath = `/assignments/add-public-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPublicPersonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdDelete: async (assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdGet: async (assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdGet', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Increment assignment submissions by 1
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdIncrementSubmissionsPost: async (assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdIncrementSubmissionsPost', 'assignmentId', assignmentId)
            const localVarPath = `/assignments/{assignmentId}/increment-submissions`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {UpdateAssignmentRequest} updateAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdPut: async (assignmentId: string, updateAssignmentRequest: UpdateAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdPut', 'assignmentId', assignmentId)
            // verify required parameter 'updateAssignmentRequest' is not null or undefined
            assertParamExists('assignmentsAssignmentIdPut', 'updateAssignmentRequest', updateAssignmentRequest)
            const localVarPath = `/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activate or deactivate an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {SetAssignmentStatusRequest} setAssignmentStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdStatusPatch: async (assignmentId: string, setAssignmentStatusRequest: SetAssignmentStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentsAssignmentIdStatusPatch', 'assignmentId', assignmentId)
            // verify required parameter 'setAssignmentStatusRequest' is not null or undefined
            assertParamExists('assignmentsAssignmentIdStatusPatch', 'setAssignmentStatusRequest', setAssignmentStatusRequest)
            const localVarPath = `/assignments/{assignmentId}/status`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAssignmentStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List assignments
         * @param {string} [cohortId] Filter assignments by cohort
         * @param {string} [ownerId] Filter assignments by owner
         * @param {AssignmentStatus} [status] Filter assignments by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsGet: async (cohortId?: string, ownerId?: string, status?: AssignmentStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cohortId !== undefined) {
                localVarQueryParameter['cohortId'] = cohortId;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an assignment
         * @param {CreateAssignmentRequest} createAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsPost: async (createAssignmentRequest: CreateAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssignmentRequest' is not null or undefined
            assertParamExists('assignmentsPost', 'createAssignmentRequest', createAssignmentRequest)
            const localVarPath = `/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify an assignment link token is valid
         * @param {string} token Assignment link token to verify
         * @param {string} [personId] If provided and the person is already in the assignment, returns 409 alreadyJoinedPublicAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsVerifyLinkTokenGet: async (token: string, personId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('assignmentsVerifyLinkTokenGet', 'token', token)
            const localVarPath = `/assignments/verify-link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add people to a cohort
         * @param {AddPeopleToCohortRequest} addPeopleToCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsAddPeoplePost: async (addPeopleToCohortRequest: AddPeopleToCohortRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPeopleToCohortRequest' is not null or undefined
            assertParamExists('cohortsAddPeoplePost', 'addPeopleToCohortRequest', addPeopleToCohortRequest)
            const localVarPath = `/cohorts/add-people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPeopleToCohortRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdDelete: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('cohortsCohortIdDelete', 'cohortId', cohortId)
            const localVarPath = `/cohorts/{cohortId}`
                .replace(`{${"cohortId"}}`, encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdGet: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('cohortsCohortIdGet', 'cohortId', cohortId)
            const localVarPath = `/cohorts/{cohortId}`
                .replace(`{${"cohortId"}}`, encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {UpdateCohortRequest} updateCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdPut: async (cohortId: string, updateCohortRequest: UpdateCohortRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('cohortsCohortIdPut', 'cohortId', cohortId)
            // verify required parameter 'updateCohortRequest' is not null or undefined
            assertParamExists('cohortsCohortIdPut', 'updateCohortRequest', updateCohortRequest)
            const localVarPath = `/cohorts/{cohortId}`
                .replace(`{${"cohortId"}}`, encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCohortRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List cohorts
         * @param {string} [organizationId] Filter cohorts by organization
         * @param {boolean} [isActive] Filter cohorts by active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsGet: async (organizationId?: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a cohort
         * @param {CreateCohortRequest} createCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsPost: async (createCohortRequest: CreateCohortRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCohortRequest' is not null or undefined
            assertParamExists('cohortsPost', 'createCohortRequest', createCohortRequest)
            const localVarPath = `/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCohortRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove people from a cohort
         * @param {RemovePeopleFromCohortRequest} removePeopleFromCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsRemovePeoplePost: async (removePeopleFromCohortRequest: RemovePeopleFromCohortRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removePeopleFromCohortRequest' is not null or undefined
            assertParamExists('cohortsRemovePeoplePost', 'removePeopleFromCohortRequest', removePeopleFromCohortRequest)
            const localVarPath = `/cohorts/remove-people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removePeopleFromCohortRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List organizations
         * @param {OrganizationsGetQueryFiltersParameter} [queryFilters] 
         * @param {OrganizationSortFieldEnum} [sortField] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet: async (queryFilters?: OrganizationsGetQueryFiltersParameter, sortField?: OrganizationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryFilters !== undefined) {
                for (const [key, value] of Object.entries(queryFilters)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdDelete: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationsOrganizationIdDelete', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdGet: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationsOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdPut: async (organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationsOrganizationIdPut', 'organizationId', organizationId)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('organizationsOrganizationIdPut', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization settings
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationSettingsRequest} updateOrganizationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdSettingsPatch: async (organizationId: string, updateOrganizationSettingsRequest: UpdateOrganizationSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('organizationsOrganizationIdSettingsPatch', 'organizationId', organizationId)
            // verify required parameter 'updateOrganizationSettingsRequest' is not null or undefined
            assertParamExists('organizationsOrganizationIdSettingsPatch', 'updateOrganizationSettingsRequest', updateOrganizationSettingsRequest)
            const localVarPath = `/organizations/{organizationId}/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an organization
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPost: async (createOrganizationRequest: CreateOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrganizationRequest' is not null or undefined
            assertParamExists('organizationsPost', 'createOrganizationRequest', createOrganizationRequest)
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search organizations by name or ID (admin only)
         * @param {string} q Search term matched against organization name or ID
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsSearchGet: async (q: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('organizationsSearchGet', 'q', q)
            const localVarPath = `/organizations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get partner dashboard data for an organization (admin only)
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDashboardAdminOrganizationIdGet: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('partnerDashboardAdminOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/partner-dashboard/admin/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get partner dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all assignments for a person
         * @param {string} personId Filter assignments by person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAssignmentsGet: async (personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('personAssignmentsGet', 'personId', personId)
            const localVarPath = `/person-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Remove a person from all assignments and cohorts (internal)
         * @param {AdminCleanupPersonRequest} adminCleanupPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCleanupPerson(adminCleanupPersonRequest: AdminCleanupPersonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCleanupPersonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCleanupPerson(adminCleanupPersonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminCleanupPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get assignment disclaimer for an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentDisclaimerGet(assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDisclaimerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentDisclaimerGet(assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentDisclaimerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a person to a public assignment and its cohort
         * @param {AddPublicPersonRequest} addPublicPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAddPublicPersonPost(addPublicPersonRequest: AddPublicPersonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPublicPersonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAddPublicPersonPost(addPublicPersonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAddPublicPersonPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdDelete(assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdDelete(assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAssignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdGet(assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdGet(assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAssignmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Increment assignment submissions by 1
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAssignmentIdIncrementSubmissionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {UpdateAssignmentRequest} updateAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdPut(assignmentId: string, updateAssignmentRequest: UpdateAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdPut(assignmentId, updateAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAssignmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Activate or deactivate an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {SetAssignmentStatusRequest} setAssignmentStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsAssignmentIdStatusPatch(assignmentId: string, setAssignmentStatusRequest: SetAssignmentStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdStatusPatch(assignmentId, setAssignmentStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsAssignmentIdStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List assignments
         * @param {string} [cohortId] Filter assignments by cohort
         * @param {string} [ownerId] Filter assignments by owner
         * @param {AssignmentStatus} [status] Filter assignments by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsGet(cohortId?: string, ownerId?: string, status?: AssignmentStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsGet(cohortId, ownerId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an assignment
         * @param {CreateAssignmentRequest} createAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsPost(createAssignmentRequest: CreateAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsPost(createAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify an assignment link token is valid
         * @param {string} token Assignment link token to verify
         * @param {string} [personId] If provided and the person is already in the assignment, returns 409 alreadyJoinedPublicAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsVerifyLinkTokenGet(token: string, personId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyLinkTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsVerifyLinkTokenGet(token, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignmentsVerifyLinkTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add people to a cohort
         * @param {AddPeopleToCohortRequest} addPeopleToCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsAddPeoplePost(addPeopleToCohortRequest: AddPeopleToCohortRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPeopleToCohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsAddPeoplePost(addPeopleToCohortRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsAddPeoplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsCohortIdDelete(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsCohortIdDelete(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsCohortIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsCohortIdGet(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsCohortIdGet(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsCohortIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {UpdateCohortRequest} updateCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsCohortIdPut(cohortId: string, updateCohortRequest: UpdateCohortRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsCohortIdPut(cohortId, updateCohortRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsCohortIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List cohorts
         * @param {string} [organizationId] Filter cohorts by organization
         * @param {boolean} [isActive] Filter cohorts by active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsGet(organizationId?: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsGet(organizationId, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a cohort
         * @param {CreateCohortRequest} createCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsPost(createCohortRequest: CreateCohortRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsPost(createCohortRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove people from a cohort
         * @param {RemovePeopleFromCohortRequest} removePeopleFromCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cohortsRemovePeoplePost(removePeopleFromCohortRequest: RemovePeopleFromCohortRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemovePeopleFromCohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cohortsRemovePeoplePost(removePeopleFromCohortRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cohortsRemovePeoplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List organizations
         * @param {OrganizationsGetQueryFiltersParameter} [queryFilters] 
         * @param {OrganizationSortFieldEnum} [sortField] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsGet(queryFilters?: OrganizationsGetQueryFiltersParameter, sortField?: OrganizationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsGet(queryFilters, sortField, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrganizationIdDelete(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrganizationIdDelete(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrganizationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrganizationIdGet(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrganizationIdPut(organizationId, updateOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrganizationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update organization settings
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationSettingsRequest} updateOrganizationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrganizationIdSettingsPatch(organizationId: string, updateOrganizationSettingsRequest: UpdateOrganizationSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrganizationIdSettingsPatch(organizationId, updateOrganizationSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrganizationIdSettingsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an organization
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsPost(createOrganizationRequest: CreateOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsPost(createOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search organizations by name or ID (admin only)
         * @param {string} q Search term matched against organization name or ID
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsSearchGet(q: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsSearchGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get partner dashboard data for an organization (admin only)
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerDashboardAdminOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerDashboardAdminOrganizationIdGet(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.partnerDashboardAdminOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get partner dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.partnerDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all assignments for a person
         * @param {string} personId Filter assignments by person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personAssignmentsGet(personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personAssignmentsGet(personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personAssignmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Remove a person from all assignments and cohorts (internal)
         * @param {AdminCleanupPersonRequest} adminCleanupPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupPerson(adminCleanupPersonRequest: AdminCleanupPersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCleanupPersonResponse> {
            return localVarFp.adminCleanupPerson(adminCleanupPersonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignment disclaimer for an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentDisclaimerGet(assignmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDisclaimerResponse> {
            return localVarFp.assignmentDisclaimerGet(assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a person to a public assignment and its cohort
         * @param {AddPublicPersonRequest} addPublicPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAddPublicPersonPost(addPublicPersonRequest: AddPublicPersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddPublicPersonResponse> {
            return localVarFp.assignmentsAddPublicPersonPost(addPublicPersonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdDelete(assignmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentsAssignmentIdDelete(assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdGet(assignmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentResponse> {
            return localVarFp.assignmentsAssignmentIdGet(assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Increment assignment submissions by 1
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentResponse> {
            return localVarFp.assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {UpdateAssignmentRequest} updateAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdPut(assignmentId: string, updateAssignmentRequest: UpdateAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentResponse> {
            return localVarFp.assignmentsAssignmentIdPut(assignmentId, updateAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activate or deactivate an assignment
         * @param {string} assignmentId Unique identifier for the assignment
         * @param {SetAssignmentStatusRequest} setAssignmentStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsAssignmentIdStatusPatch(assignmentId: string, setAssignmentStatusRequest: SetAssignmentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentResponse> {
            return localVarFp.assignmentsAssignmentIdStatusPatch(assignmentId, setAssignmentStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List assignments
         * @param {string} [cohortId] Filter assignments by cohort
         * @param {string} [ownerId] Filter assignments by owner
         * @param {AssignmentStatus} [status] Filter assignments by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsGet(cohortId?: string, ownerId?: string, status?: AssignmentStatus, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentListResponse> {
            return localVarFp.assignmentsGet(cohortId, ownerId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an assignment
         * @param {CreateAssignmentRequest} createAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsPost(createAssignmentRequest: CreateAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentResponse> {
            return localVarFp.assignmentsPost(createAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify an assignment link token is valid
         * @param {string} token Assignment link token to verify
         * @param {string} [personId] If provided and the person is already in the assignment, returns 409 alreadyJoinedPublicAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsVerifyLinkTokenGet(token: string, personId?: string, options?: RawAxiosRequestConfig): AxiosPromise<VerifyLinkTokenResponse> {
            return localVarFp.assignmentsVerifyLinkTokenGet(token, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add people to a cohort
         * @param {AddPeopleToCohortRequest} addPeopleToCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsAddPeoplePost(addPeopleToCohortRequest: AddPeopleToCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddPeopleToCohortResponse> {
            return localVarFp.cohortsAddPeoplePost(addPeopleToCohortRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdDelete(cohortId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cohortsCohortIdDelete(cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdGet(cohortId: string, options?: RawAxiosRequestConfig): AxiosPromise<CohortResponse> {
            return localVarFp.cohortsCohortIdGet(cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a cohort
         * @param {string} cohortId Unique identifier for the cohort
         * @param {UpdateCohortRequest} updateCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsCohortIdPut(cohortId: string, updateCohortRequest: UpdateCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<CohortResponse> {
            return localVarFp.cohortsCohortIdPut(cohortId, updateCohortRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List cohorts
         * @param {string} [organizationId] Filter cohorts by organization
         * @param {boolean} [isActive] Filter cohorts by active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsGet(organizationId?: string, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CohortListResponse> {
            return localVarFp.cohortsGet(organizationId, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a cohort
         * @param {CreateCohortRequest} createCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsPost(createCohortRequest: CreateCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<CohortResponse> {
            return localVarFp.cohortsPost(createCohortRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove people from a cohort
         * @param {RemovePeopleFromCohortRequest} removePeopleFromCohortRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cohortsRemovePeoplePost(removePeopleFromCohortRequest: RemovePeopleFromCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemovePeopleFromCohortResponse> {
            return localVarFp.cohortsRemovePeoplePost(removePeopleFromCohortRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List organizations
         * @param {OrganizationsGetQueryFiltersParameter} [queryFilters] 
         * @param {OrganizationSortFieldEnum} [sortField] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet(queryFilters?: OrganizationsGetQueryFiltersParameter, sortField?: OrganizationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationListResponse> {
            return localVarFp.organizationsGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdDelete(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationsOrganizationIdDelete(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.organizationsOrganizationIdGet(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace an organization
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.organizationsOrganizationIdPut(organizationId, updateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization settings
         * @param {string} organizationId Unique identifier for the organization
         * @param {UpdateOrganizationSettingsRequest} updateOrganizationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrganizationIdSettingsPatch(organizationId: string, updateOrganizationSettingsRequest: UpdateOrganizationSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.organizationsOrganizationIdSettingsPatch(organizationId, updateOrganizationSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an organization
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPost(createOrganizationRequest: CreateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.organizationsPost(createOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search organizations by name or ID (admin only)
         * @param {string} q Search term matched against organization name or ID
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsSearchGet(q: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationSearchResult>> {
            return localVarFp.organizationsSearchGet(q, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get partner dashboard data for an organization (admin only)
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDashboardAdminOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDashboardResponse> {
            return localVarFp.partnerDashboardAdminOrganizationIdGet(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get partner dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<PartnerDashboardResponse> {
            return localVarFp.partnerDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all assignments for a person
         * @param {string} personId Filter assignments by person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personAssignmentsGet(personId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentListResponse> {
            return localVarFp.personAssignmentsGet(personId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Remove a person from all assignments and cohorts (internal)
     * @param {AdminCleanupPersonRequest} adminCleanupPersonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminCleanupPerson(adminCleanupPersonRequest: AdminCleanupPersonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminCleanupPerson(adminCleanupPersonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignment disclaimer for an assignment
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentDisclaimerGet(assignmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentDisclaimerGet(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a person to a public assignment and its cohort
     * @param {AddPublicPersonRequest} addPublicPersonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAddPublicPersonPost(addPublicPersonRequest: AddPublicPersonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAddPublicPersonPost(addPublicPersonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an assignment
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAssignmentIdDelete(assignmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAssignmentIdDelete(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an assignment
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAssignmentIdGet(assignmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAssignmentIdGet(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Increment assignment submissions by 1
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAssignmentIdIncrementSubmissionsPost(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace an assignment
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {UpdateAssignmentRequest} updateAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAssignmentIdPut(assignmentId: string, updateAssignmentRequest: UpdateAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAssignmentIdPut(assignmentId, updateAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activate or deactivate an assignment
     * @param {string} assignmentId Unique identifier for the assignment
     * @param {SetAssignmentStatusRequest} setAssignmentStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsAssignmentIdStatusPatch(assignmentId: string, setAssignmentStatusRequest: SetAssignmentStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsAssignmentIdStatusPatch(assignmentId, setAssignmentStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List assignments
     * @param {string} [cohortId] Filter assignments by cohort
     * @param {string} [ownerId] Filter assignments by owner
     * @param {AssignmentStatus} [status] Filter assignments by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsGet(cohortId?: string, ownerId?: string, status?: AssignmentStatus, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsGet(cohortId, ownerId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an assignment
     * @param {CreateAssignmentRequest} createAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsPost(createAssignmentRequest: CreateAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsPost(createAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify an assignment link token is valid
     * @param {string} token Assignment link token to verify
     * @param {string} [personId] If provided and the person is already in the assignment, returns 409 alreadyJoinedPublicAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignmentsVerifyLinkTokenGet(token: string, personId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignmentsVerifyLinkTokenGet(token, personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add people to a cohort
     * @param {AddPeopleToCohortRequest} addPeopleToCohortRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsAddPeoplePost(addPeopleToCohortRequest: AddPeopleToCohortRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsAddPeoplePost(addPeopleToCohortRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a cohort
     * @param {string} cohortId Unique identifier for the cohort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsCohortIdDelete(cohortId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsCohortIdDelete(cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a cohort
     * @param {string} cohortId Unique identifier for the cohort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsCohortIdGet(cohortId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsCohortIdGet(cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a cohort
     * @param {string} cohortId Unique identifier for the cohort
     * @param {UpdateCohortRequest} updateCohortRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsCohortIdPut(cohortId: string, updateCohortRequest: UpdateCohortRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsCohortIdPut(cohortId, updateCohortRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List cohorts
     * @param {string} [organizationId] Filter cohorts by organization
     * @param {boolean} [isActive] Filter cohorts by active status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsGet(organizationId?: string, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsGet(organizationId, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a cohort
     * @param {CreateCohortRequest} createCohortRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsPost(createCohortRequest: CreateCohortRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsPost(createCohortRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove people from a cohort
     * @param {RemovePeopleFromCohortRequest} removePeopleFromCohortRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cohortsRemovePeoplePost(removePeopleFromCohortRequest: RemovePeopleFromCohortRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cohortsRemovePeoplePost(removePeopleFromCohortRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List organizations
     * @param {OrganizationsGetQueryFiltersParameter} [queryFilters] 
     * @param {OrganizationSortFieldEnum} [sortField] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsGet(queryFilters?: OrganizationsGetQueryFiltersParameter, sortField?: OrganizationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an organization
     * @param {string} organizationId Unique identifier for the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrganizationIdDelete(organizationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrganizationIdDelete(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an organization
     * @param {string} organizationId Unique identifier for the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrganizationIdGet(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace an organization
     * @param {string} organizationId Unique identifier for the organization
     * @param {UpdateOrganizationRequest} updateOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrganizationIdPut(organizationId, updateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization settings
     * @param {string} organizationId Unique identifier for the organization
     * @param {UpdateOrganizationSettingsRequest} updateOrganizationSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrganizationIdSettingsPatch(organizationId: string, updateOrganizationSettingsRequest: UpdateOrganizationSettingsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrganizationIdSettingsPatch(organizationId, updateOrganizationSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an organization
     * @param {CreateOrganizationRequest} createOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsPost(createOrganizationRequest: CreateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsPost(createOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search organizations by name or ID (admin only)
     * @param {string} q Search term matched against organization name or ID
     * @param {number} [limit] Maximum number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsSearchGet(q: string, limit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsSearchGet(q, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get partner dashboard data for an organization (admin only)
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public partnerDashboardAdminOrganizationIdGet(organizationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).partnerDashboardAdminOrganizationIdGet(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get partner dashboard data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public partnerDashboardGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).partnerDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all assignments for a person
     * @param {string} personId Filter assignments by person ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personAssignmentsGet(personId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personAssignmentsGet(personId, options).then((request) => request(this.axios, this.basePath));
    }
}



